import { jsx as _jsx } from "react/jsx-runtime";
export default function StatusIndicator({ status }) {
    return (_jsx("div", { className: "ms3-status-indicator" +
            (status ? " ms3-status-indicator--" + status : "") }));
}
